import {DataTableHeaderCommunicationService, HeaderComponent} from '@Common/widgets/general/data-table';
import {BehaviorSubject} from 'rxjs';

/**
 * Classe utilitaire pour les filtres colonnes, pour signatures à utiliser
 * @example
  export class FilterColumnComponent extends HeaderFilterService implements OnInit, OnDestroy {
    constructor(public dtCommunicationSvc: DataTableHeaderCommunicationService) {
       super(dtCommunicationSvc);
    }
    sendAllReinit(reinit: boolean) {
      // traitement
    }
    sendReinit(filterName: string) {
      // traitement
    }
    onValidate(event) {
       // traitement
    }
    onCancel(event) {
      // traitement
    }
   }
 */
export abstract class HeaderFilterService implements HeaderComponent {
  data: any;
  name: string;
  subject: BehaviorSubject<any> = new BehaviorSubject(null);
  subject$ = this.subject.asObservable();
  protected constructor(public dtCommunicationSvc: DataTableHeaderCommunicationService) {
    this.initCommunications();
  }
  protected initCommunications() {
    this.dtCommunicationSvc.sendAllFiltersReinit$.subscribe((value: boolean) => {
      if (value) {
        this.sendAllReinit(value);
      }
    });
    this.dtCommunicationSvc.sendFilterReinit$.subscribe((name: string) => {
      if (this.name === name) {
        this.sendReinit(name);
      }
    });
  }

  /**
   * Réinit filtre, message à envoyer à la data-table
   * @param reinit
   */
  abstract sendAllReinit(reinit: boolean);
  abstract sendReinit(filterName: string);

  /**
   * Filtrage / annulation
   * pour les boutons du filtre
   */
  /**
   * @example
   onValidate(event) {
    const dataEmit = <DataEmitFilterModel> {
      nameComponent: this.name,
      action: 'validate',
      value: this.value,
      condition: this.value ? `sur ${this.value}` : ''
    };
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit);
  }
   */
  abstract onValidate(event);

  /**
   * @example
     onCancel(event) {
       const dataEmit = <DataEmitFilterModel> {nameComponent: this.name, action: 'reinit'};
       this.subject.next(dataEmit);
       this.dtCommunicationSvc.filterUsed(this.name, dataEmit, false);
     }
   * @param event
   */
  abstract onCancel(event);
}
